import type { InsertBlockPluginOptions } from '@atlaskit/editor-plugin-insert-block';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

export function insertBlockPluginOptions(): InsertBlockPluginOptions {
	return {
		allowTables: true,
		allowExpand: true,
		horizontalRuleEnabled: true,
		tableSelectorSupported: editorExperiment('platform_editor_tables_table_selector', true),
		nativeStatusSupported: true,
		showElementBrowserLink: true,
		appearance: 'full-page',
	};
}
